
export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
    sponsorList: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      sponsorItem: null,
    };
  },
  computed: {
    getLinkedPages () {
      return this.sponsorList ? this.sponsorList.pages.map(page => page.associated_page) : null;
    },
    isSelectedPage () {
      const findCorrrespondinPage = this.getLinkedPages.find(page => page.ID === this.post.id);
      return !!findCorrrespondinPage;
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.getSponsor();
    });
  },
  methods: {
    async getSponsor () {
      if (this.sponsorList?.sponsor.sponsor) {
        const params = {
          fields: `id,title,acf,image`,
          posts: {
            per_page: 1,
            p: this.sponsorList?.sponsor.sponsor.ID,
            post_type: `partner`,
          },
        };

        const request = await this.$getPosts(`/posts`, params);
        if (request !== null) {
          this.sponsorItem = request[0];
        }
      }
    },
  },
};
